<template>
  <div class="lineB">
    <h1 class="tit">{{damageType[name]}}</h1>
    <div v-for="(cList, index) in listData" class="line" :key="index">
      <cell :title="cList.note" class="tagQreport"
            v-if="cList.damageList[0].key === '1' && cList.damageList[0].selected">
        <span slot="value">{{cList.title.join(' ')}}</span>
      </cell>
      <cell :title="cList.note" class="tagQreport2" v-else>
        <span slot="after-title">
          <span>{{cList.title.join(' ')}}</span>
        </span>
        <span slot="value" class="pic">
          <img src="../../../stylesheets/images/manage/quality.png"
               v-show="cList.images.length === cList.count"
               @click="onClick(cList)"/>
          <i class="img-loading" v-show="cList.images.length !== cList.count"></i>
          <img class="pictures" v-for="(image, index) in cList.images" :key="index" />
          <images-previewer :list="filterImages(cList.images, index)" :ref="'previewer_'+cList.id" :options="options"
                     @on-close="onClose(index)"></images-previewer>
          <div v-show="textShow" class="previewer-demo-text">{{currentTitle}}</div>
        </span>
      </cell>
    </div>
  </div>
</template>
<script>
import {
  Cell
  // Previewer
} from '@lx-frontend/cvux'
import ImagesPreviewer from '@lx-frontend/images-previewer'
export default {
  components: {
    Cell,
    ImagesPreviewer
    // Previewer
  },
  data() {
    return {
      listData: [],
      damageType: {
        skeletonDamage: '骨架损伤',
        metalRepair: '钣金修复',
        appearanceDamage: '外观损伤',
        waterCheck: '泡水检测',
        fireCheck: '火烧检测',
        inDecoration: '内饰',
        machines: '机械',
        appliances: '电器'
      },
      options: {
        getThumbBoundsFn(index) {
          let thumbnail = document.querySelectorAll('.pictures')[index]
          let pageYScroll = window.pageYOffset || document.documentElement.scrollTop
          let rect = thumbnail.getBoundingClientRect()
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          }
        }
      },
      currentTitle: '',
      textShow: false,
      imgCount: 0 // 图片的总数
    }
  },
  methods: {
    onClick(item) {
      if (item.images.length === item.count) {
        this.currentTitle = ''
        let id = item.id
        // 图片预览
        this.$refs[`previewer_${id}`][0].show(0)
        // 修改title
        let title = item.note + ' ' + item.title.join('、')
        if (item.message) {
          title += '(' + item.message + ')'
        }
        this.currentTitle = title
        // 展示title
        this.textShow = true
      }
    },
    onClose(index) {
      this.textShow = false
    },
    filterImages(list, index) {
      let arr = []
      list.forEach(v => {
        if (v) {
          let img = new window.Image()
          img.src = v
          let item = { src: v }
          // 如果图片被缓存，则直接返回缓存数据
          if (img.complete) {
            item.w = img.width
            item.h = img.height
          } else {
            // 完全加载完毕的事件
            img.onload = function () {
              item.w = img.width
              item.h = img.height
            }
          }
          arr.push(item)
        }
      })
      return arr
    }
  },
  props: {
    item: {
      type: Array,
      default() {
        return []
      }
    },
    name: String
  },
  watch: {
    item(newValue, oldValue) {
      let newItem = JSON.parse(JSON.stringify(newValue))
      newItem.forEach((a, index) => { a.count = 0 })
      this.listData = JSON.parse(JSON.stringify(newItem))
      this.listData.forEach((a, index) => {
        if (a.images && a.images.length > 0) {
          a.images.forEach((v) => {
            let img = new window.Image()
            img.src = v
            // 如果图片被缓存，则直接返回缓存数据
            if (img.complete) {
              this.listData[index].count++
            } else {
              // 完全加载完毕的事件
              img.onload = () => {
                this.listData[index].count++
              }
            }
          })
        }
      })
    }
  }
}
</script>
<style lang="less">
  @import "../../../stylesheets/modules/manage/qreport.less";
  .tagQreport .weui_cell_primary {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    padding-right: 20px;
    & > p {
      color: #888;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }

  .tagQreport2 .weui_cell_primary {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    padding-right: 20px;
    & > p {
      color: #f00;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }

  .previewer-demo-text {
    position: fixed;
    bottom: 0px;
    left: 0px;
    color: #fff;
    z-index: 9999;
    padding: 5px 10px;
    text-align: left;
    line-height: 24.5/37.5rem;
    background-color: #000;
    opacity: 0.6;
  }
  // loading 加载按钮
  .img-loading {
    position: relative;
    top: 14 / @w2;
    right: 0;
    background-color: #e7e7e9;
    width: 36 / @w2;
    height: 36 / @w2;
    border-radius: 100%;
    animation-fill-mode: both;
    border: 4 / @w2 solid #e7e7e9;
    border-bottom-color: transparent;
    background: transparent !important;
    display: inline-block;
    animation: vinLoadingRotate 0.75s 0s linear infinite;
  }

  // loading 加载动画
  @keyframes vinLoadingRotate {
    0% {
      transform: rotate(0deg);
    }

    50% {
      transform: rotate(180deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }
</style>
